<template>
  <a-spin :spinning="spinning">
    <a-card :body-style="{padding: '24px 32px'}" :bordered="false">
      <a-form @submit="handleSubmit" :form="form">
        <a-form-item
          label="优惠券"
          :labelCol="{lg: {span: 7}, sm: {span: 7}}"
          :wrapperCol="{lg: {span: 10}, sm: {span: 17} }"
        >
          <a-select
            :getPopupContainer="trigger => trigger.parentNode"
            @change="handleSelectChange"
            v-decorator="[
            'SelectCoupon',
            {rules: [{ required: true, message: '请选择优惠券.' }]}
          ]"
            placeholder="请选择优惠券"
          >
            <a-select-option
              v-for="(item, index) in couponList"
              :key="index"
              :value="item.u_couponsetting_id"
            >{{item.couponame}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-spin :spinning="spinning_lod">
          <template v-if="JSON.stringify(couponInfo)!='{}'">
            <a-form-item
              label="优惠券剩余数量"
              :labelCol="{lg: {span: 7}, sm: {span: 7}}"
              :wrapperCol="{lg: {span: 10}, sm: {span: 17} }"
              v-if="couponInfo.totalcount==0&&couponInfo.lifecyc==0"
            >
              <span style=" color: green; ">无上限</span>
            </a-form-item>
            <a-form-item
              label="优惠券剩余数量"
              :labelCol="{lg: {span: 7}, sm: {span: 7}}"
              :wrapperCol="{lg: {span: 10}, sm: {span: 17} }"
              v-else-if="couponInfo.remaincount>=0"
            >
              <span style=" color: green; ">{{couponInfo.remaincount}}</span>
            </a-form-item>
            <a-form-item
              label="优惠券减免金额"
              :labelCol="{lg: {span: 7}, sm: {span: 7}}"
              :wrapperCol="{lg: {span: 10}, sm: {span: 17} }"
            >
              <span style=" color: green; ">{{couponInfo.discount}}</span>
            </a-form-item>
          </template>
          <a-form-item
            label="有无车牌号"
            :labelCol="{lg: {span: 7}, sm: {span: 7}}"
            :wrapperCol="{lg: {span: 10}, sm: {span: 17} }"
          >
            <a-radio-group @change="onChange" v-model="phoneORlicense" defaultValue="true">
              <a-radio-button value="true">有车牌</a-radio-button>
              <a-radio-button value="false">无车牌</a-radio-button>
            </a-radio-group>
          </a-form-item>
          <template v-if="phoneORlicense === 'false'">
            <a-form-item
              label="手机号码"
              :labelCol="{lg: {span: 7}, sm: {span: 7}}"
              :wrapperCol="{lg: {span: 10}, sm: {span: 17} }"
              :extra="extraLicenseInfo"
            >
              <a-select
                :getPopupContainer="trigger => trigger.parentNode"
                showSearch
                placeholder="请输入手机号（当前优惠券需手机号有关联订单）"
                :defaultActiveFirstOption="false"
                :showArrow="false"
                :filterOption="false"
                @search="handlePhoneSearch"
                @change="handlePhoneChange"
                :notFoundContent="null"
                v-decorator="[
            'phone',
            {rules: [{ required: true, message: '请输入手机号' }, {
                  validator: this.handleConfirmPhone
            }]}
          ]"
                ref="phone"
                v-if="couponInfo.isneedorders===1"
              >
                <a-select-option v-for="d in phoneSelectData" :key="d.mobile">{{d.mobile}}</a-select-option>
              </a-select>
              <a-input
                v-else
                v-decorator="[
            'phone',
            {rules: [{ required: true, message: '请输入手机号' }, {
                  validator: this.handleConfirmPhone
            }]}
          ]"
                ref="phone"
                placeholder="请输入手机号"
                @change="inputhandlePhoneChange"
              ></a-input>
            </a-form-item>
          </template>
          <template v-else>
            <a-form-item
              label="车牌号码"
              :labelCol="{lg: {span: 7}, sm: {span: 7}}"
              :wrapperCol="{lg: {span: 10}, sm: {span: 17} }"
              :extra="extraLicenseInfo"
            >
              <a-select
                :getPopupContainer="trigger => trigger.parentNode"
                showSearch
                placeholder="请输入车牌号（当前优惠券需手机号有关联订单）"
                :defaultActiveFirstOption="false"
                :showArrow="false"
                :filterOption="false"
                @search="handleLicenseSearch"
                @change="handleLicenseChange"
                :notFoundContent="null"
                v-decorator="[
              'licens',
              {rules: [{ required: true, message: '请输入车牌号' }]}
              ]"
                ref="licens"
                v-if="couponInfo.isneedorders===1"
              >
                <a-select-option
                  v-for="d in licenseSelectData"
                  :key="d.licenseplate"
                >{{d.licenseplate}}</a-select-option>
              </a-select>
              <a-input
                v-else
                v-decorator="[
              'licens',
              {rules: [{ required: true, message: '请输入车牌号' }]}
              ]"
                ref="licens"
                placeholder="请输入车牌号"
                @change="inputhandleLicenseChange"
              ></a-input>
            </a-form-item>
          </template>
          <a-form-item
            label="备注"
            :labelCol="{lg: {span: 7}, sm: {span: 7}}"
            :wrapperCol="{lg: {span: 10}, sm: {span: 17} }"
          >
            <a-textarea
              :rows="4"
              v-decorator="[
            'memo',
          ]"
              placeholder="请输入说明备注"
            />
          </a-form-item>
          <a-form-item :wrapperCol="{ span: 24 }" style="text-align: center">
            <a-button htmlType="submit" type="primary">提交</a-button>
            <a-button style="margin-left: 8px" @click="resetForm">重置</a-button>
            <a-button style="margin-left: 8px" @click="handleGoBack">返回</a-button>
          </a-form-item>
        </a-spin>
      </a-form>
    </a-card>
  </a-spin>
</template>
<script>
import {
  getSelectCouponsList,
  getCouponsInfo,
  getLicenseplateInfo,
  getLicenseplateInfoByMobile,
  AddCoupons,
  getLicenseplateLikeQuery,
  getLicenseplateLikeQueryByPhone
} from '@/api/SellerCoupons'
import { message, notification } from 'ant-design-vue'
import { MillisecondToDate, getLocalTime } from '@/utils/util'
import debounce from 'lodash/debounce'
export default {
  data() {
    this.LicenseplateQuery = debounce(this.LicenseplateQuery, 300)
    return {
      //优惠券下拉数据
      couponList: {},
      //优惠券信息
      couponInfo: {},
      extraLicenseInfo: '暂无车辆信息',
      phoneORlicense: 'true',
      form: this.$form.createForm(this),
      licenseSelectData: [],
      phoneSelectData: [],
      spinning: true,
      spinning_lod: false
    }
  },
  //@blur="getLicenseplateInfoByMobile()"
  //@blur="getLicenseplateInfo()"
  mounted: function() {
    getSelectCouponsList({ couponType: '3' }).then(res => {
      this.couponList = res.result
      this.spinning = false
    })
  },
  methods: {
    LicenseplateQuery(value) {
      this.licenseSelectData = []
      getLicenseplateLikeQuery({ licenseplate: value }).then(res => {
        if (res.status === 0) {
          this.licenseSelectData = res.result
        }
      })
    },
    PhoneQuery(value) {
      this.phoneSelectData = []
      getLicenseplateLikeQueryByPhone({ phone: value }).then(res => {
        if (res.status === 0) {
          this.phoneSelectData = res.result
        }
      })
    },
    handleLicenseSearch(value) {
      var v = value.toUpperCase() //2019-07-03
      this.LicenseplateQuery(v) //2019-07-03
    },
    handlePhoneSearch(value) {
      this.PhoneQuery(value)
    },
    //2019-07-03
    getLicenseplateInfo(strlicens) {
      //车牌
      if (this.phoneORlicense === 'true') {
        //获取车牌号码input的值
        //var licens = this.$refs.licens.value
        getLicenseplateInfo({ licenseplate: strlicens }).then(res => {
          if (res.status === 0) {
            if (res.result != null && JSON.stringify(res.result) != '{}') {
              var strMes =
                '入场时间：' + res.result.createdate + ',    已停时长：' + MillisecondToDate(res.result.parkingtime)
              this.extraLicenseInfo = strMes
            } else {
              this.extraLicenseInfo = '未查询到车辆信息'
            }
          }
        })
      }
    },
    //2019-07-03
    getLicenseplateInfoByMobile(strMobile) {
      //手机号
      if (this.phoneORlicense === 'false') {
        //获取手机号码input的值
        //var phone = this.$refs.phone.value
        getLicenseplateInfoByMobile({ mobile: strMobile, islicenseplate: false }).then(res => {
          if (res.status === 0) {
            if (res.result != null && res.result != {}) {
              var strMes =
                '入场时间：' + res.result.createdate + ',    已停时长：' + MillisecondToDate(res.result.parkingtime)
              this.extraLicenseInfo = strMes
            } else {
              this.extraLicenseInfo = '未查询到车辆信息'
            }
          }
        })
      }
    },
    onChange(e) {
      //指定重置车牌号和手机号输入框（不重置会出现验证bug
      //this.resetForm() //2019-07-03
      this.form.resetFields(['licens', 'phone', 'memo'])
      this.extraLicenseInfo = '暂无车辆信息'
    },
    handleSelectChange(e) {
      this.spinning_lod = true
      this.resetForm() //2019-07-03
      this.form.resetFields(['licens', 'phone', 'memo'])
      getCouponsInfo({ id: e }).then(res => {
        if (res.status == 0) {
          this.spinning_lod = false
          this.couponInfo = res.result
        } else {
          this.spinning_lod = false
          this.$notification['error']({
            message: '错误',
            description: ((err.response || {}).data || {}).message || '错误代码：' + res.status + '，请稍后再试',
            duration: 4
          })
          this.couponInfo = {}
        }
      })
    },
    //2019-07-03
    inputhandlePhoneChange(e) {
      //var strMobile = this.inputMobile
      var v = e.target.value
      if (v.length == 11) {
        this.getLicenseplateInfoByMobile(v) //2019-07-03
      }
    },
    handlePhoneChange(e) {
      if (e.length == 11) {
        this.getLicenseplateInfoByMobile(e) //2019-07-03
      }
    },
    //2019-07-03
    inputhandleLicenseChange(e) {
      //var strMobile = this.inputMobile
      //console.log(e.target.value)
      var v = e.target.value
      if (v.length == 7 || v.length == 8) {
        this.getLicenseplateInfo(v) //2019-07-03
      } else {
        this.extraLicenseInfo = '未查询到车辆信息' //2019-07-03
      }
    },
    handleLicenseChange(e) {
      this.getLicenseplateInfo(e) //2019-07-03
    },
    resetForm() {
      this.form.resetFields()
      this.couponInfo = {}
      this.extraLicenseInfo = '暂无车辆信息'
    },
    handleGoBack() {
      this.$emit('onGoBack')
    },
    //提交后进入方法
    handleSubmit(e) {
      var VM = this
      //阻止表单默认事件
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: '确认提交?',
            onOk() {
              const data = {
                'uCoupons.u_parkingarea_id': VM.couponInfo.u_parkingarea_id,
                'uCoupons.u_couponsetting_id': VM.couponInfo.u_couponsetting_id,
                'uCoupons.licenseplate': values.licens,
                'uCoupons.phone': values.phone,
                'uCoupons.allcount': 1,
                'uCoupons.memo': values.memo
              }
              AddCoupons(data).then(res => {
                if (res.status === 0) {
                  notification.success({
                    message: '提交成功！',
                    description: '页面将在2秒后自动重置'
                  })
                  setTimeout(() => {
                    VM.resetForm()
                  }, 2000)
                } else {
                  notification.error({
                    message: '提交失败！',
                    description: res.message
                  })
                }
              })
            },
            onCancel() {}
          })
        }
      })
    },
    //2019-07-03
    handleConfirmPhone(rule, value, callback) {
      //关于获取字段值https://laracasts.com/discuss/channels/vue/can-i-get-an-input-value-with-vue
      if (value && !/^1\d{10}$/.test(value)) {
        callback('请输入正确的手机号！')
      }
      this.extraLicenseInfo = '未查询到车辆信息' //2019-07-03
      // Note: 必须总是返回一个 callback，否则 validateFieldsAndScroll 无法响应
      callback()
    }
  }
}
</script>
<style>
.ant-form-extra {
  color: #1790ff;
}
</style>
